import { render, staticRenderFns } from "./CustomList.vue?vue&type=template&id=c88b5558&scoped=true&"
import script from "./CustomList.vue?vue&type=script&lang=js&"
export * from "./CustomList.vue?vue&type=script&lang=js&"
import style0 from "./CustomList.vue?vue&type=style&index=0&id=c88b5558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88b5558",
  null
  
)

export default component.exports